import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Blog/Hero";
import IndustriesContent from "../components/Blog/IndustriesContent";
import PageTitle from "../components/Blog/PageTitle";

import '../assets/Webdevelopment.css';



const Blog = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  </div>
	)
}

export default Blog;
